import React from 'react'
import GeneralInfoFormContainer from '../../templates/general-info/GeneralInfoFormContainer'
import Navbar from '../../templates/navbar/Navbar'
import withParams from '../../../modules/router-manage/withParams'
import PortalHeader from '../../templates/navbar/PortalHeader'

const GeneralInfoPage = ({ params: { portalID } }) => (
  <div>
    <Navbar portalID={portalID} />
    <div className="container">
      <div className="section">
        <PortalHeader portalID={portalID} />
        <hr />
        <GeneralInfoFormContainer />
      </div>
    </div>
  </div>
)

export default withParams(GeneralInfoPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/GeneralInfoPage.js